/* eslint-disable @next/next/no-page-custom-font */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { useEffect, useState } from 'react';
import '../styles/globals.css';
import '../styles/normalize.css';
import { ThemeProvider } from '@mui/system';
import customTheme from '@config/styles/customTheme';
import { ApolloProvider } from '@config/apollo';
import { ToastProvider } from '@hooks/toast.hook';

import CssBaseline from '@mui/material/CssBaseline';
import packageJson from '../../../package.json';
import { init } from '../src/utils/sentry';
import { useTrack } from '@hooks/useTrack';
import {
  initializeAmplitude,
  preloadCountryDetection,
} from '@services/amplitude';

import '../src/utils/wdyr';
import { useVhFix } from '@hooks/useVhFix';
import { useSessionId } from '@hooks/useSessionId';
import { AuthStateProvider } from '@hooks/useAuth';
import { MekiStateProvider } from '@hooks/useMekiState';
import { OrderStateProvider } from '@hooks/useOrderState';
import { CartMenuProvider } from '@hooks/useCartMenu';
import { ScrollProvider } from '@hooks/useScroll';
import { OpenModalProvider } from '@hooks/useModalOpenState';
import { FocusSearchBoxProvider } from '@hooks/useFocusSearchBox';
import { OrderInPaymentValidationProvider } from '@hooks/useOrderInPaymentValidation';
import { PillBoxProvider } from '@screens/home/components/virtualPillBox/hooks/usePillBoxState';
import {
  BASE_URL,
  GOOGLE_TAG_MANAGER,
  NEXT_PUBLIC_AMPLITUDE_API_KEY,
  NEXT_PUBLIC_PIXEL_ID,
} from '@config/environment';
import { useOpenReplay } from '@services/openreplay';
import Head from 'next/head';
import { useRefererParam } from '@hooks/useRefererParam';
import { AddressFormDataProvider } from '@screens/address/hooks/useAddressFormData';
import { useRouterHistory } from '@hooks/useRouterHistory';
import { ReferralsNoNewUserDialog } from '@components/ReferralsNoNewUserDialog';
import { ModalNavigation } from '@components/ModalNavigation';
import createEmotionCache from '../src/createEmotionCache';
import { CacheProvider } from '@emotion/react';

// eslint-disable-next-line no-console
const Track = () => {
  React.useEffect(() => {
    setTimeout(init);
    void preloadCountryDetection();
    initializeAmplitude();
  }, []);
  useTrack();
  return null;
};
const clientSideEmotionCache = createEmotionCache();
console.log(`Version ${packageJson.version}`);
function MyApp({
  Component,
  pageProps,
  emotionCache = clientSideEmotionCache,
  err,
}) {
  const [loaded, setLoaded] = useState(false);
  useVhFix();
  useSessionId();
  useOpenReplay();
  useRefererParam();
  useRouterHistory();
  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);

  useEffect(function handleLoaded() {
    setLoaded(true);
  }, []);
  return (
    <>
      <CacheProvider value={emotionCache}>
        <Head>
          <meta
            name="viewport"
            content="initial-scale=1, viewport-fit=cover maximum-scale=1.5"
          />
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin="anonymous"
          />
          <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
          <link rel="dns-prefetch" href="https://fonts.gstatic.com" />
          {GOOGLE_TAG_MANAGER && (
            // eslint-disable-next-line @next/next/next-script-for-ga
            <script
              id="tag-manager"
              dangerouslySetInnerHTML={{
                __html: `window.dataLayer = [];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER}');`,
              }}
              async
            ></script>
          )}
          {NEXT_PUBLIC_PIXEL_ID && (
            <>
              <script
                type="text/script"
                dangerouslySetInnerHTML={{
                  __html: `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${NEXT_PUBLIC_PIXEL_ID}');
fbq('track', 'PageView');`,
                }}
              ></script>
              <noscript>
                <img
                  alt="facebook"
                  height="1"
                  width="1"
                  style={{ display: 'none' }}
                  src={`https://www.facebook.com/tr?id=${NEXT_PUBLIC_PIXEL_ID}&ev=PageView&noscript=1`}
                />
              </noscript>
            </>
          )}

          {loaded && (
            <>
              <link
                href="https://fonts.googleapis.com/icon?family=Material+Icons&display=swap"
                rel="stylesheet"
              />
              <link
                href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
                rel="stylesheet"
              />
            </>
          )}
          <noscript>
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/icon?family=Material+Icons&display=swap"
            />
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
            />
          </noscript>
        </Head>
        <ToastProvider>
          <ApolloProvider>
            <AuthStateProvider>
              <Track />
              <MekiStateProvider>
                <OrderStateProvider>
                  <AddressFormDataProvider>
                    <CartMenuProvider>
                      <FocusSearchBoxProvider>
                        <ThemeProvider theme={customTheme}>
                          <CssBaseline />
                          <ScrollProvider>
                            <OpenModalProvider>
                              <PillBoxProvider>
                                <OrderInPaymentValidationProvider>
                                  <Component {...pageProps} err={err} />
                                  <ModalNavigation {...pageProps} />
                                </OrderInPaymentValidationProvider>
                              </PillBoxProvider>
                              <ReferralsNoNewUserDialog />
                            </OpenModalProvider>
                          </ScrollProvider>
                        </ThemeProvider>
                      </FocusSearchBoxProvider>
                    </CartMenuProvider>
                  </AddressFormDataProvider>
                </OrderStateProvider>
              </MekiStateProvider>
            </AuthStateProvider>
          </ApolloProvider>
        </ToastProvider>
      </CacheProvider>
    </>
  );
}

export default MyApp;
